<div class="h-100 side-nav fixed top-0 shadow h-screen bg-white z-40 flex flex-col"
  [ngClass]="isShow ? 'right-0' : 'hide-nav'">

  <header class="flex items-center justify-between border-bottom px-7 py-4">

    <button matRipple color="primary" (click)="toggleNav()" aria-label="Drawer Close Button"
      class="flex items-center justify-center rounded-full h-9 w-9">
      <i class="ico-ArrowRight text-2xl"></i>
    </button>

    <img [src]="cdnUrl + '/images/iho-logo.png'" alt="IranHotelOnline's Logo" role="logo" height="24px" width="152px">
  </header>


  <nav class="px-8 flex flex-col mx-auto w-full">
    <mat-accordion class="custom-footer-accordion lg:hidden !text-black w-full mt-2">
      <mat-expansion-panel [expanded]="true" class="border-bottom">
        <mat-expansion-panel-header class="!px-0">
          <mat-panel-title>
            <h6 class="">
              <a href="https://www.iranhotelonline.com/"
                class="py-2 text-black text-base font-bold block cursor-pointer px-0 hover:pr-1 transition-all">رزرو
                هتل</a>
            </h6>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ul>
          <li class="text-base text-muted"><a (click)="toggleNav()" href="/mashhad-hotels/"
              class="py-2 block cursor-pointer px-0 hover:pr-1 transition-all">هتل های مشهد</a></li>
          <li class="text-base text-muted"><a (click)="toggleNav()" href="/tehran-hotels/"
              class="py-2 block cursor-pointer px-0 hover:pr-1 transition-all">هتل های تهران</a></li>
          <li class="text-base text-muted"><a (click)="toggleNav()" href="/shiraz-hotels/"
              class="py-2 block cursor-pointer px-0 hover:pr-1 transition-all">هتل های شیراز</a></li>
          <li class="text-base text-muted"><a (click)="toggleNav()" href="/isfahan-hotels/"
              class="py-2 block cursor-pointer px-0 hover:pr-1 transition-all">هتل های اصفهان</a></li>
          <li class="text-base text-muted"><a (click)="toggleNav()" href="/kish-hotels/"
              class="py-2 block cursor-pointer px-0 hover:pr-1 transition-all">هتل های کیش</a></li>
        </ul>

      </mat-expansion-panel>
    </mat-accordion>

    <h6 class="py-4 border-bottom" matRipple><a href="https://www.iranhotelonline.com/ecolodge/" target="_blank"
        class="text-base font-bold text-black block">ویلا و بومگردی</a></h6>
    <h6 class="py-4 border-bottom" matRipple>
      <a href="https://b2b.iranhotelonline.com/" target="_blank" class="text-base font-bold text-black block">
      شرکت ها و آژانس ها
      </a>
    </h6>

    <h6 class="py-4 border-bottom" matRipple><a href="https://www.iranhotelonline.com/iran-hotels/" target="_blank"
        class="text-base font-bold text-black block">هتل های ایران</a></h6>

    <h6 class="py-4" matRipple><a href="https://www.iranhotelonline.com/international-hotels/" target="_blank"
        class="text-base font-bold text-black block">هتل‌ های خارجی</a></h6>
  </nav>




</div>